import { render, staticRenderFns } from "./CompetitionIndex.vue?vue&type=template&id=0a85901a&scoped=true"
import script from "./CompetitionIndex.vue?vue&type=script&lang=js"
export * from "./CompetitionIndex.vue?vue&type=script&lang=js"
import style0 from "./CompetitionIndex.vue?vue&type=style&index=0&id=0a85901a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85901a",
  null
  
)

export default component.exports